// @flow
import * as React from 'react';

import Draggable from 'react-draggable';
import { Card } from 'react-toolbox/lib/card';
import keypress from 'keypress.js';

import theme from './styles.scss';

type Props = {
    keyCombination: string,
    defaultVisible?: boolean,
    draggableCancel?: ?string,
    render: ({ hide: () => void }) => React.Node
};

const DraggableBox = ({
    keyCombination,
    defaultVisible = false,
    render,
    draggableCancel
}: Props): React.Node => {
    const [visible, setVisible] = React.useState(defaultVisible);

    const hide = () => {
        setVisible(false);
    };

    const toggle = () => {
        setVisible(val => !val);
    };

    React.useEffect(() => {
        if (!keyCombination) {
            return;
        }

        const listener = new keypress.Listener();
        listener.register_many([
            {
                keys: keyCombination,
                is_exclusive: true,
                is_sequence: true,
                on_keydown: toggle
            },
            {
                keys: 'esc',
                is_exclusive: true,
                on_keydown: hide
            }
        ]);

        return () => listener.destroy();
    }, [keyCombination]);

    if (!visible) {
        return null;
    }

    return (
        <div className={theme.boxOverlay}>
            <Draggable cancel={draggableCancel}>
                <Card className={theme.boxWrap} theme={theme}>
                    {render({ hide })}
                </Card>
            </Draggable>
        </div>
    );
};

export default DraggableBox;
